<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <main class="facilitator settings">
    <section class="settings">
      <form @submit.prevent="submitForm">
        <fieldset>
          <div class="field flow">
            <label>flow</label>
            <div>
              <label v-for="(label, key) in GameSessionFlow" :key="key" class="radio">
                <input v-model="form.flow" type="radio" :value="key" name="flow" />
                <span class="label">{{ label }}</span>
              </label>
            </div>
          </div>

          <div class="field">
            <label>seconds per round</label>
            <div>
              <input
                v-model="form.secondsPerRound"
                type="text"
                inputmode="numeric"
                name="secondsPerRound"
                :readonly="!isSessionPending"
              />
            </div>
          </div>

          <div class="field">
            <label>HDMA will be effective after active for x rounds</label>
            <div>
              <input
                v-model="form.hdmaEffectiveRoundCount"
                type="text"
                inputmode="numeric"
                name="hdmaEffectiveRoundCount"
                :readonly="!isSessionPending"
              />
            </div>
          </div>
        </fieldset>

        <fieldset class="actions">
          <button type="submit" :disabled="form.processing">
            <span v-if="isSessionPending">save settings</span>
            <span v-else>update settings</span>
          </button>
        </fieldset>
      </form>
    </section>
  </main>
</template>

<script setup lang="ts">
import { useForm } from '@inertiajs/vue3'
import { computed } from 'vue'

import GameLayout from '/@front:layouts/game.vue'
import { GameSessionFlow } from '/@front:shared/constants'
import { success } from '/@front:shared/notifications'
import type { GameSession } from '/@front:types/shared'

defineOptions({
  layout: [GameLayout],
})

const props = defineProps<{
  settings: Record<string, number | boolean | string>
  session: GameSession
  links: Record<string, string>
}>()

const form = useForm({
  flow: props.settings.flow,
  secondsPerRound: props.settings.secondsPerRound,
  hdmaEffectiveRoundCount: props.settings.hdmaEffectiveRoundCount,
})

const isSessionPending = computed(() => props.session.status.value === 'pending')

const submitForm = () => {
  form.post(props.links.sessionSettings, {
    preserveState: false,
    onFinish: () => {
      finishForm()
    },
  })
}

const finishForm = () => {
  success('Settings saved.')
}
</script>
